import { useParams } from "../../../Providers/ParamsProvider"

const useGetProductIndexWithMask = () => {
    const { indexMask } = useParams()

    const getProductIndexWithMask = (index) => {
        if (!indexMask || !index) {
            return index
        }
        let result = ""
        let indexPos = 0

        for (let i = 0; i < indexMask.length; i++) {
            const maskChar = indexMask[i]
            if (maskChar === "!") {
                if (indexPos < index.length) {
                    result += index[indexPos]
                    indexPos++
                }
            } else {
                result += maskChar
            }
        }
        return result
    }

    return { getProductIndexWithMask }
}

export default useGetProductIndexWithMask